import axios from 'axios'
import Constants from '../constants'

export default {
  getFavorites: (token) => {
    return new Promise((resolve, reject) => {
      const params = {
        id: Constants.API_ID,
        token: token
      }

      axios.get('favorite', { params })
        .then((payload) => {
          resolve(payload.data.poi.map(id => parseInt(id) || id))
        })
        .catch(() =>  reject())
    })
  },
  putFavorite: (place, token) => {
    return new Promise((resolve, reject) => {
      const params = {
        id: Constants.API_ID,
        token: token,
        poiId: place.id
      }

      axios.put('favorite', params)
        .then(() => resolve())
        .catch(() =>  reject())
    })
  },
  deleteFavorite: (place, token) => {
    return new Promise((resolve, reject) => {
      const params = {
        id: Constants.API_ID,
        token: token,
        poiId: place.id
      }

      axios.delete('favorite', { data: params })
        .then(() => resolve())
        .catch(() => reject())
    })
  }
}
